// extracted by mini-css-extract-plugin
module.exports = {"processRow":"ProcessesModal_processRow__3hvg2"};